import { render, staticRenderFns } from "./routeLoading.vue?vue&type=template&id=73dc7730&"
import script from "./routeLoading.vue?vue&type=script&lang=js&"
export * from "./routeLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports